import {createContext} from "react";

export const ApploadContext = createContext({
    loading: true,
    setLoading: () => {
    }
});